import { getTracesSampleRate } from '@user-portal/sentry-utils';

import Sentry from './Sentry';

export default new Sentry({
    sentryDSN: import.meta.env.SENTRY_DSN,
    env: import.meta.env.ENV,
    release: `${import.meta.env.AWS_DELIVERY_STREAM_NAME}_${import.meta.env.ENV}_${import.meta.env.RELEASE_DATE}`,
    tracesSampleRate: getTracesSampleRate(import.meta.env.ENV ?? ''),
    autoSessionTracking: true,
});
